import * as Sentry from '@sentry/svelte'
import type { HandleClientError } from '@sveltejs/kit'

Sentry.init({
  dsn: 'https://b4b992ea87b53207f14c16211a18d66b@o4506613635416064.ingest.us.sentry.io/4506613637513216',
})

const logClientError: HandleClientError = ({ error, message, event, status }) => {
  if (status !== 404) {
    Sentry.captureException(error, {
      tags: { status },
      extra: { message, path: event.url.pathname },
    })
  }
  console.error(`[client] ${status} ${event.url.pathname}: ${message}`)
  console.error(error)
}

export const handleError = logClientError
